import styled from 'styled-components'

export const ContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
`

export const ContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0.25rem 0.5rem;
`

export const InfoTable = styled.div`
  align-items: flex-start;
  display: grid;
  gap: 8px 6px;
  grid-template-columns: auto 1fr;
`

export const IconWrapper = styled.div`
  padding: 4px;
`

export const Type = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`
